import { FC, useState } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ProductFormData, TOption } from '@src/types';
import { Divider, InputSelect, MultiSelect, SectionToggle } from '@features/ui';
import { startDateCalculationOptions } from '@features/admin/productsAddons/productsAddonsData.ts';

interface ProductAvailabilityFormProps {
  productOptions: TOption[];
}
export const ProductAvailabilityForm: FC<
  UseFormReturn<ProductFormData> & ProductAvailabilityFormProps
> = ({ control, formState: { errors }, productOptions }) => {
  const [hide, setHide] = useState(false);

  return (
    <div className={'text-xs mb-[77px]'}>
      <Divider />
      <SectionToggle className={'mt-[15px]'} toggle={hide} onChange={setHide} />
      {!hide && (
        <div
          className={
            'flex lg:flex-row flex-col 2xl:w-[80%] w-full gap-x-[81px] gap-y-6 mt-11'
          }
        >
          <Controller
            control={control}
            name="required_product_ids"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-1'}>
                <p className={'ml-2 mb-1'}>
                  To order this product user must have an
                </p>
                <MultiSelect
                  options={productOptions}
                  placeholder={'Select'}
                  value={field.value}
                  onChange={(value) => field.onChange(value)}
                />
                <p>
                  when user orders this subscription, it will be checked that
                  user has at least one of the following subscriptions
                </p>
              </div>
            )}
          />
          <Controller
            control={control}
            name="disallow_product_ids"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-1'}>
                <p className={'ml-2 mb-1'}>
                  Disallow ordering of this product if user has
                </p>
                <MultiSelect
                  options={productOptions}
                  placeholder={'Select'}
                  value={field.value}
                  onChange={(value) => field.onChange(value)}
                />
                <p>
                  {`when user orders this subscription, it will be checked that he doesn't have any of the following subscriptions`}
                </p>
              </div>
            )}
          />
          <Controller
            control={control}
            name="start_date_calculation"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-1'}>
                <p className={'ml-2 mb-1'}>Start Date Calculation</p>
                <InputSelect
                  className={'text-xs'}
                  error={!!errors.start_date_calculation?.message}
                  options={startDateCalculationOptions}
                  placeholder={'Select'}
                  value={field.value}
                  onChange={(value) => field.onChange(value)}
                />
                <p>
                  {`rules for subscription start date calculation.MAX date from alternatives will be chosen.This settings has no effect for recurring subscriptions`}
                </p>
              </div>
            )}
          />
        </div>
      )}
    </div>
  );
};
